var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoVolumeMute = function SvgVideoVolumeMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.907 2.061a.5.5 0 0 1 .26.439v11a.5.5 0 0 1-.77.421L4.395 11.36a.17.17 0 0 0-.09-.027H2.333a1.167 1.167 0 0 1-1.166-1.166V5.833c0-.644.522-1.166 1.166-1.166h1.972q.049 0 .09-.027L8.397 2.08a.5.5 0 0 1 .51-.018M15.187 7.02a.5.5 0 0 0-.707-.707l-1.06 1.06-1.062-1.06a.5.5 0 0 0-.707.707l1.061 1.061-1.06 1.06a.5.5 0 0 0 .707.708l1.06-1.06 1.06 1.06a.5.5 0 0 0 .708-.707l-1.06-1.061z"
  })));
};
export default SvgVideoVolumeMute;